import "../../../css/paymentPage/PaymentPage.css"
import LocationCode from "../../../utils/constants/LocationCode";
import {useState} from "react";
import UserSelector from "../../../elements/selector/UserSelector";
import PaymentMethods from "../../../utils/constants/PaymentMethods";
import proxy from '../../../utils/Proxy.js'

let PaymentPage = (props) => {
    let [username, setUsername] = useState(null);
    let [userid, setUserid] = useState(null);
    let [paymentMethod, setPaymentMethod] = useState(0);
    let [startDateNonset, setStartDateNonset] = useState(false);

    let onMethodAdd = (_) => {
        let selector = document.getElementById("payment-method-select");
        let selectedValue = parseInt(selector.value);
        if (!PaymentMethods.containsMethod(paymentMethod, selectedValue))
            setPaymentMethod(paymentMethod + selectedValue)
    }
    let onMethodRemove = (e) => {
        let elementId = e.target.id;
        let id = parseInt(elementId.split(":")[1]);
        setPaymentMethod(paymentMethod - id);
    }
    let onStartdateNonset = (e) => {
        let elements = document.querySelectorAll(".payment-date")
        for (let element of elements) {
            element.disabled = e.target.checked;
        }
        setStartDateNonset(e.target.checked)
    }
    let getPaymentMethods = () => {
        let ret = []
        if (paymentMethod === 0)
            return ret;
        let methods = PaymentMethods.getPaymentMethods(paymentMethod)
        for (let methodIndex in methods) {
            let methodId = methods[methodIndex]
            let text = PaymentMethods.text[methodId];
            let id = text + ":" + methodId;

            ret.push((
                <div className="payment-method-item-container" key={id}>
                    <p className="payment-method-item">
                        {text}
                    </p>
                    <div className="payment-method-item-delete" id={id} onClick={onMethodRemove.bind(this)}></div>
                </div>))
        }
        return ret;
    }

    let getNowDateNum = () => {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month < 10 ? "0" + month : month;
        let day = date.getDate();
        day = day < 10 ? "0" + day : day;
        return [year, month, day]
    }

    let onSubmitClicked = (_) => {
        let requestUserid = userid;

        let monthsInput = document.getElementById("payment-month-input");
        let months = parseNullableInt(monthsInput.value);

        let lessonCountInput = document.getElementById("payment-lesson-count-input");
        let lessonCount = parseNullableInt(lessonCountInput.value);

        let requestPaymentMethod = paymentMethod;

        let paymentAmountInput = document.getElementById("payment-amount-input");
        let paymentAmount = parseNullableInt(paymentAmountInput.value);

        let registerChecked = document.querySelector('input[name="is-reregister"]:checked');
        let is_reregister = registerChecked === null ? null : parseInt(registerChecked.value);

        let startDate = "";
        let startYear = document.getElementById("startdate-year").value;
        let startMonth = document.getElementById("startdate-month").value;
        let startDay = document.getElementById("startdate-day").value;

        startDate += startYear + "-" + startMonth + "-" + startDay;

        let endDate = "";
        let endYear = document.getElementById("enddate-year").value;
        let endMonth = document.getElementById("enddate-month").value;
        let endDay = document.getElementById("enddate-day").value;

        endDate += endYear + "-" + endMonth + "-" + endDay;

        let paymentDate = "";
        let paymentYear = document.getElementById("paymentdate-year").value;
        let paymentMonth = document.getElementById("paymentdate-month").value;
        let paymentDay = document.getElementById("paymentdate-day").value;

        paymentDate += paymentYear + "-" + paymentMonth + "-" + paymentDay

        let etcInput = document.getElementById("payment-etc");
        let etc = etcInput.value;

        let maxHoldingAmountInput = document.getElementById("payment-max-holding-amount-input");
        let maxHoldingAmount = parseNullableInt(maxHoldingAmountInput.value) ?? 0;

        let validCheck = requestUserid !== null && months !== null && lessonCount !== null
            && requestPaymentMethod !== 0 && paymentAmount !== null && is_reregister !== null
            && isDate(paymentDate) && isValidDate(paymentDate)

        if (!startDateNonset) {
            if(! isDate(startDate) || ! isDate(endDate) || ! isValidDate(startDate) || ! isValidDate(endDate))
                return alert("잘못된 날짜가 입력되었습니다. 날짜를 확인하신 후 다시 시도해주세요.")
        }

        if (!validCheck) {
            return alert("필수 값들이 아직 입력되지 않았거나 잘못된 값이 입력되었습니다. 확인 후 다시 시도해주세요.")
        }
        let body = {
            userid: requestUserid,
            months: months,
            lesson_count: lessonCount,
            is_reregister: is_reregister,
            method: requestPaymentMethod,
            payment_date: paymentDate,
            payment_amount: paymentAmount,
            etc: etc,
            max_holding_amount: maxHoldingAmount
        }
        if (startDateNonset) {
            body.start = null;
            body.end = null;
            body.startdate_non_set = true;
        } else {
            body.start = startDate;
            body.end = endDate;
            body.startdate_non_set = false;
        }

        proxy.post("/adminapi/payments", body).then(res => {
            window.alert(res.data.message);
            monthsInput.value = "";
            lessonCountInput.value = "";
            setPaymentMethod(0)
            paymentAmountInput.value = "";
            setUserid(null)
            setUsername(null)
            etcInput.value = ""
            document.getElementById("startdate-year").value = getNowDateNum()[0]
            document.getElementById("startdate-month").value = getNowDateNum()[1]
            document.getElementById("startdate-day").value = getNowDateNum()[2]

            document.getElementById("enddate-year").value = "";
            document.getElementById("enddate-month").value = "";
            document.getElementById("enddate-day").value = "";

            document.getElementById("paymentdate-year").value = getNowDateNum()[0]
            document.getElementById("paymentdate-month").value = getNowDateNum()[1]
            document.getElementById("paymentdate-day").value = getNowDateNum()[2]

            document.getElementById("startdate-nonset").checked = false;
            setStartDateNonset(false);

            let elements = document.querySelectorAll(".payment-date")
            for (let element of elements) {
                element.disabled = false;
            }
        }).catch(err => {
            window.alert(err.response.data.message)
        })
    }

    let isDate = (value) => {
        return typeof value === "string" && !isNaN(Date.parse(value)) && value.split("-").length === 3
    }

    let isValidDate = (value) => {
        let dateSplit = value.split("-");
        let year = parseInt(dateSplit[0]);
        let month = parseInt(dateSplit[1]) - 1;
        let date = parseInt(dateSplit[2]);

        let endDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
        if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
            endDays[1] = 29;
        }
        return 1 <= date && date <= endDays[month]
    }

    let parseNullableInt = (n) => {
        return n === "" ? null : parseInt(n);
    }

    let onClickResult = (user) => {
        setUsername(user.name)
        setUserid(user.userid)
    }

    return (<div className="content-container">
        <div className="content-title">
            <p>결제 정보 등록</p>
        </div>
        <div className="payment-container">
            <div className="payment-item-container">
                <ul>
                    <li>
                        <div className="payment-item">
                            <p>수강 지점: {LocationCode.text[props.location]}</p>
                        </div>
                    </li>
                    <li>
                        <div className="payment-item">
                            <p>수강생 선택: {username === null ? "" : username}</p>
                            <div className="payment-margin-15px"></div>
                            <UserSelector onClickResult={onClickResult} />
                        </div>
                    </li>
                    <li>
                        <div className="payment-item">
                            <p>레슨 기간: </p>
                            <input id="payment-month-input" className="payment-input" required></input>
                            <p>개월</p>
                        </div>
                    </li>
                    <li>
                        <div className="payment-item">
                            <p>레슨 횟수: </p>
                            <input id="payment-lesson-count-input" className="payment-input" required></input>
                            <p>회</p>
                        </div>
                    </li>
                    <li>
                        <div className="payment-item">
                            <p>결제 방법: </p>
                            <select id="payment-method-select" className="payment-input">
                                <option value="1">신용카드</option>
                                <option value="4">계좌이체</option>
                                <option value="2">현금</option>
                            </select>
                            <div id="payment-method-button" onClick={onMethodAdd}>
                                <p>추가</p>
                            </div>
                            {getPaymentMethods()}
                        </div>
                    </li>
                    <li>
                        <div className="payment-item">
                            <p>결제 금액: </p>
                            <input id="payment-amount-input" className="payment-input"
                                   placeholder="숫자만 기재" required></input>
                        </div>
                    </li>
                    <li>
                        <div className="payment-item">
                            <p>등록 분류: </p>
                            <input type="radio" id="reregister-true" name="is-reregister" value={1}/>
                            <label htmlFor="reregister-true">재등록</label>
                            <input type="radio" id="reregister-false" name="is-reregister" value={0}/>
                            <label htmlFor="reregister-false">신규 등록</label>
                        </div>
                    </li>
                    <li>
                        <div className="payment-item">
                            <p>등록 기간: </p>
                            <div className="payment-input payment-date-container" id="payment-startdate">
                                <input className="payment-date payment-date-year"
                                       defaultValue={getNowDateNum()[0]} id="startdate-year"></input>
                                <p>-</p>
                                <input className="payment-date payment-date-month-day"
                                       defaultValue={getNowDateNum()[1]} id="startdate-month"></input>
                                <p>-</p>
                                <input className="payment-date payment-date-month-day"
                                       defaultValue={getNowDateNum()[2]} id="startdate-day"></input>
                            </div>
                            ~
                            <div className="payment-input payment-date-container" id="payment-enddate">
                                <input className="payment-date payment-date-year"
                                       id="enddate-year"></input>
                                <p>-</p>
                                <input className="payment-date payment-date-month-day"
                                       id="enddate-month"></input>
                                <p>-</p>
                                <input className="payment-date payment-date-month-day"
                                       id="enddate-day"></input>
                            </div>
                            <p>시작일 미정</p>
                            <input type="checkbox" id="startdate-nonset" onChange={onStartdateNonset}></input>
                        </div>
                    </li>
                    <li>
                        <div className="payment-item">
                            <p>결제일: </p>
                            <div className="payment-input payment-date-container" id="payment-date">
                                <input className="payment-submit-date payment-date-year"
                                       defaultValue={getNowDateNum()[0]} id="paymentdate-year" required></input>
                                <p>-</p>
                                <input className="payment-submit-date payment-date-month-day"
                                       defaultValue={getNowDateNum()[1]} id="paymentdate-month" required></input>
                                <p>-</p>
                                <input className="payment-submit-date payment-date-month-day"
                                       defaultValue={getNowDateNum()[2]} id="paymentdate-day" required></input>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="payment-item">
                            <p>비고: </p>
                            <input className="payment-input" id="payment-etc"></input>
                        </div>
                    </li>
                    <li>
                        <div className="payment-item">
                            <p>최대 홀딩 가능일: </p>
                            <input className="payment-input"
                                id="payment-max-holding-amount-input"
                                style={{ marginLeft: "10px", paddingLeft: "10px" }}
                                type="number"
                            >
                            </input>
                        </div>
                    </li>
                </ul>
                <div className="payment-item payment-submit-button-container">
                    <div id="payment-submit-button" onClick={onSubmitClicked.bind(this)}>
                        <p>결제 정보 저장</p>
                    </div>
                </div>
            </div>
        </div>
    </div>)
}
export default PaymentPage;